<div [ngSwitch]="status">
  <div *ngSwitchCase="enumQStatus.Finished" class="status-q respond">
    <img src="/assets/images/grid/status/answered.svg">
    <p translate>grid.status.finished</p>
  </div>
  <div *ngSwitchCase="enumQStatus.InProgress" class="status-q distributed">
    <img src="/assets/images/grid/status/distributed.svg">
    <p translate>grid.status.in-progress</p>
  </div>
  <div *ngSwitchCase="enumQStatus.NotStarted" class="status-q edit">
    <img src="/assets/images/grid/status/edit.svg">
    <p translate> grid.status.not-started</p>
  </div>
   <div *ngSwitchCase="enumQStatus.Template" class="status-q template">
    <img src="/assets/images/grid/status/distributed.svg">
    <p translate> grid.status.template</p>
  </div>
  <div *ngSwitchCase="enumQStatus.PendingApproval" class="status-q pendingApproval">
    <img src="/assets/images/grid/status/hourglass.svg">
    <p translate> grid.status.pendingApproval</p>
  </div>
  <div *ngSwitchCase="enumQStatus.Rejected" class="status-q rejected">
    <img src="/assets/images/grid/status/cancel.svg">
    <p translate> grid.status.rejected</p>
  </div>
  <div *ngSwitchCase="enumQStatus.Approved" class="status-q approved">
    <img src="/assets/images/grid/status/check_circle.svg">
    <p translate> grid.status.approved</p>
  </div>
</div>